import {
  MarketActivityItem,
  MarketFilter,
  MarketPagination,
  SummaryStat,
} from 'store/market-activity/types';
import {apiMethod, APIService} from '../APIService';

export interface ActivityListResult {
  count: number;
  list: MarketActivityItem[];
}

class MarketActivityApi extends APIService {
  fetchSummaryStats = apiMethod<SummaryStat>(
    (filter: MarketFilter, options: {fresh?: 0 | 1; summaryDays?: 7} = {}) => this.fetcher.request({
      method: 'GET',
      url: `/api/market-activity/summary/`,
      params: {
        ...filter,
        ...options
      }
    }),
  );

  fetchActivityList = apiMethod(
    (filter: MarketFilter, pager: MarketPagination, options: {fresh?: 0 | 1} = {}) => this.fetcher.request<ActivityListResult>({
      method: 'GET',
      url: `/api/market-activity/list/`,
      params: {
        ...filter,
        ...pager,
        ...options
      }
    }),
  );

  fetchCityInfo = apiMethod(
    (cityId: number) => this.fetcher.request({
      method: 'GET',
      url: `/api/market-activity/city-info/${cityId}/`,
    })
  );

  // Difference from PartnerAPI, need to create partner request + update market history item by UUID
  addToPartner = apiMethod(
    (userId: number, uuid: string) => this.fetcher.request({
      method: 'GET',
      url: `/api/market-activity/add-partner/`,
      params: {
        userId,
        uuid
      }
    })
  );

  confirmPartner = apiMethod(
    (userId: number, uuid: string) => this.fetcher.request({
      method: 'GET',
      url: `/api/market-activity/confirm-partner/`,
      params: {
        userId,
        uuid
      }
    })
  );
}

export {MarketActivityApi};
